/*
 * @Description: portal Mutations
 */
import { MutationTree } from 'vuex'
import { PortalState } from './state'
import { PortalMutationTypes } from './mutation-types'
import { UserInfo } from '@/store/modules/user/state'

export type Mutations<S = PortalState> = {
    [PortalMutationTypes.SET_PORTAL_INFO](state: S, portalInfo: UserInfo): void
}

export const mutations: MutationTree<PortalState> & Mutations = {
    [PortalMutationTypes.SET_PORTAL_TOKEN](state: PortalState, portalToken: string) {
        state.portalToken = portalToken
    },
    [PortalMutationTypes.SET_PORTAL_CURRENT_PAGE_ID](state: PortalState, portalCurrentPageId: number) {
        state.portalCurrentPageId = portalCurrentPageId
    },
    [PortalMutationTypes.SET_PORTAL_INFO](state: PortalState, portalInfo: UserInfo) {
        state.portalInfo = portalInfo
    },
    [PortalMutationTypes.SET_PORTAL_LOADING](state: PortalState, portalLoading: boolean) {
        state.portalLoading = portalLoading
    },
    [PortalMutationTypes.SET_PORTAL_TITLE](state: PortalState, PortalTitle: string) {
        state.portalTitle = PortalTitle
    },
    [PortalMutationTypes.SET_PORTAL_ISMOBILE](state: PortalState, isMobile: boolean) {
        state.isMobile = isMobile
    },
}
